export var ApiServiceLevelEnum;
(function (ApiServiceLevelEnum) {
    ApiServiceLevelEnum["FREE"] = "free";
    ApiServiceLevelEnum["PRO"] = "pro";
    ApiServiceLevelEnum["BUSINESS"] = "business";
    ApiServiceLevelEnum["ENTERPRISE"] = "enterprise";
    ApiServiceLevelEnum["UNLIMITED"] = "unlimited";
})(ApiServiceLevelEnum || (ApiServiceLevelEnum = {}));
export var StripeBillingIntervalEnum;
(function (StripeBillingIntervalEnum) {
    StripeBillingIntervalEnum["MONTH"] = "month";
    StripeBillingIntervalEnum["YEAR"] = "year";
})(StripeBillingIntervalEnum || (StripeBillingIntervalEnum = {}));
export var ProductUseCasesEnum;
(function (ProductUseCasesEnum) {
    ProductUseCasesEnum["IN_APP"] = "in_app";
    ProductUseCasesEnum["MULTI_CHANNEL"] = "multi_channel";
    ProductUseCasesEnum["DELAY"] = "delay";
    ProductUseCasesEnum["TRANSLATION"] = "translation";
    ProductUseCasesEnum["DIGEST"] = "digest";
})(ProductUseCasesEnum || (ProductUseCasesEnum = {}));
//# sourceMappingURL=organization.js.map